import { useTranslation } from 'react-i18next';

function useDetectRTL() {
    var i18n = useTranslation().i18n;
    return i18n.dir() === 'rtl';
}

export { useDetectRTL };
//# sourceMappingURL=rtl.hook.js.map
